var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6439 14.2621H18.7583V17.1477H21.6439V14.2621ZM20.867 16.3708H19.5352V15.039H20.867V16.3708Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8148 10.433H14.9292V13.3188H17.8148V10.433ZM17.0379 12.5419H15.7061V11.21H17.0379V12.5419Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32718 14.2621H3.46924V17.1477H6.35483L6.35502 14.2621H6.32718ZM5.55026 16.3708H4.21846V15.039H5.55026V16.3708Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32718 18.0911H3.46924V20.9767H6.35483L6.35502 18.0911H6.32718ZM5.55026 20.1998H4.21846V18.868H5.55026V20.1998Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6439 10.433H18.7583V13.3188H21.6439V10.433ZM20.867 12.5419H19.5352V11.21L20.867 11.2099V12.5419Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8148 18.0911H14.9292V20.9767H17.8148V18.0911ZM17.0379 20.1998H15.7061V18.868H17.0379V20.1998Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9854 14.2621H11.0996V17.1477H13.9852L13.9854 14.2621ZM13.2085 16.3708H11.8767V15.039H13.2085V16.3708Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1566 18.0911H7.271V20.9767H10.1566V18.0911ZM9.37967 20.1998H8.04786V18.868H9.37967V20.1998Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9854 10.433H11.0996V13.3188H13.9852L13.9854 10.433ZM13.2085 12.5419H11.8767V11.21H13.2085V12.5419Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1566 10.433H7.271V13.3188H10.1566V10.433ZM9.37967 12.5419H8.04786V11.21H9.37967V12.5419Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8148 14.2621H14.9292V17.1477H17.8148V14.2621ZM17.0379 16.3708H15.7061V15.039H17.0379V16.3708Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1566 14.2621H7.271V17.1477H10.1566V14.2621ZM9.37967 16.3708H8.04786V15.039H9.37967V16.3708Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9854 18.0911H11.0996V20.9767H13.9852L13.9854 18.0911ZM13.2085 20.1998H11.8767L11.8765 18.868H13.2083L13.2085 20.1998Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9201 1.22098H18.9245C18.758 0.527304 18.1476 6.10352e-05 17.3984 6.10352e-05C16.6491 6.10352e-05 16.0387 0.527304 15.8446 1.22098H9.24079C9.07434 0.527304 8.43622 6.10352e-05 7.68701 6.10352e-05C6.93779 6.10352e-05 6.32735 0.527304 6.13322 1.22098H2.1653C1.44393 1.22098 0.833496 1.80376 0.833496 2.55278V23.6683C0.833496 24.3896 1.41628 25.0001 2.1653 25.0001H22.8923C23.6137 25.0001 24.2241 24.4173 24.2241 23.6683L24.2243 2.52504C24.2243 1.80352 23.6415 1.22093 22.9202 1.22093L22.9201 1.22098ZM16.5938 1.58175C16.5938 1.13775 16.9546 0.777185 17.3984 0.777185C17.8424 0.777185 18.2029 1.13796 18.2029 1.58175V2.66388C18.2029 3.10788 17.8422 3.46845 17.3984 3.46845C16.9544 3.46845 16.5938 3.10768 16.5938 2.66388V1.58175ZM6.88234 1.58175C6.88234 1.13775 7.24311 0.777185 7.68691 0.777185C8.1309 0.777185 8.49147 1.13796 8.49147 1.58175V2.66388C8.49147 3.10788 8.1307 3.46845 7.68691 3.46845C7.24291 3.46845 6.88234 3.10768 6.88234 2.66388V1.58175ZM1.63816 2.5251C1.63816 2.21987 1.88784 1.99785 2.1654 1.99785H6.07778V2.66383C6.07778 3.55184 6.79915 4.27316 7.6871 4.27316H7.90911C8.71367 4.16225 9.32415 3.4407 9.32415 2.60824V1.99781H15.7892V2.66378C15.7892 3.55179 16.5106 4.27311 17.3985 4.27311H17.6205C18.4251 4.16221 19.0356 3.44065 19.0356 2.60819V1.99776H22.948C23.2532 1.99776 23.4752 2.24743 23.4752 2.525V7.21429H1.63831L1.63816 2.5251ZM23.4473 23.6406C23.4473 23.9458 23.1976 24.1678 22.9201 24.1678H2.1653C1.86008 24.1678 1.63806 23.9181 1.63806 23.6406L1.63825 8.04675H23.4474L23.4473 23.6406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.2286d3ae3dc3ed14ebb8b43f7c114d74.svg";
export { ForwardRef as ReactComponent };